enum OutlookAvailability {
    none = 1,
    available = 2,
    other = 3 // This means that Outlook isn't the default, but another one is available as a share target.
}

export default OutlookAvailability;